module.exports = __webpack_public_path__ + "img/child.cf7cd5d1.svg";